import { generator } from '../event-listener.js';
export const OnBeforeFetch = generator('onBeforeFetch');
export const OnAfterFetch = generator('onAfterFetch');
export const OnAbort = generator('onAbort');
//# sourceMappingURL=fetchable.js.map